import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { PurchaseDocumentHistoryFilters } from '../../models/PurchaseDocumentHistory';

const usePurchaseDocumentHistoryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [
        fetchingGetPurchaseDocumentHistoriesByInvoice,
        setFetchingGetPurchaseDocumentHistoriesByInvoice
    ] = useState(false);

    const getAllPurchaseDocumentHistoriesByInvoice = (
        purchaseDocumentId: number,
        filter: PurchaseDocumentHistoryFilters,
        events: ServiceEvents = {}
    ) => {

        const queryString = Object.entries(filter)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
        const url = `${EndPoints.PURCHASE_DOCUMENT_HISTORY.GET_PURCHASE_DOCUMENT_HISTORIES_BY_PURCHASE_DOCUMENT}?${queryString}`;

        doGet({
            ...events,
            url: url.replace(
                ':purchase_document_id',
                purchaseDocumentId.toString()
            ),
            setFetching: setFetchingGetPurchaseDocumentHistoriesByInvoice
        });
    };

    return {
        getAllPurchaseDocumentHistoriesByInvoice,
        fetchingGetPurchaseDocumentHistoriesByInvoice
    };
};

export default usePurchaseDocumentHistoryService;
